<template>
  <div>
    <QuillInputS
      name="body"
      display-name=""
      placeholder="Body here"
      :value="block.quill"
      :editor-overlay="block.overlay"
      :editor-background="img(block.file)"
      @quillChanged="quillChanged"
    ></QuillInputS>

    <div class="row my-3">
      <div class="col-12 col-md-6">
        <ImageUpload
          :file-path="block.file"
          @uploadCompleted="storeFile"
          @fileDeleted="deleteFile"
          context="block.image"
        ></ImageUpload>
      </div>

      <div class="col">
        <div class="mb-3">
          <label for="">{{ 'Background color' | translate }}:</label>
          <ColorPicker base="#ffffff" :color="block.overlay" @input="setColor"></ColorPicker>
        </div>
        <div class="mb-3" v-if="blockOptions">
          <label>{{ 'Size' | translate }}</label>
          <select class="form-control" v-model="blockOptions.size">
            <option value="sm">{{ 'Contained' | translate }}</option>
            <option value="lg">{{ 'Full screen' | translate }}</option>
          </select>
        </div>
      </div>

      <div class="col-12">
        <div class="mt-3" v-if="blockOptions">
          <label>{{ 'Url' | translate }}</label>
          <input class="form-control" type="text" v-model="blockOptions.url" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import route from './../../routes.js'
import ImageUpload from './../ImageUpload'
import QuillInputS from './../QuillInputS'
import ColorPicker from '~/app2/components/ColorPicker'

export default {
  components: {
    ImageUpload,
    QuillInputS,
    ColorPicker,
  },
  props: ['block'],
  data() {
    return {
      blockOptions: {
        size: 'lg',
        url: null
      },
    }
  },
  mounted() {
    if (this.block.settings && (this.block.settings.size || this.block.settings.url)) {
      this.blockOptions = this.block.settings
    }
  },
  updated() {
    this.setSettings()
  },
  methods: {
    setSettings() {
      this.block.settings = this.blockOptions
    },
    setColor(value) {
      this.block.overlay = value
    },
    deleteFile() {
      this.block.file = null
      this.$emit('fileDeleted')
    },
    storeFile(filePath) {
      this.block.file = filePath
      this.$emit('fileUploaded')
    },
    quillChanged(html, quill) {
      this.block.quill = quill
      this.block.html = html
    },
    img(url) {
      if (!url) {
        return false
      }
      return route.image(url)
    },
  },
}
</script>
